import { isNumber, size, trim } from '@libs/shared';
import { DEFAULT_FIELD_REGEX } from '../constants';

/**
 * 富文本内容限制
 * @param text
 * @param limit
 * @param fieldRegexp
 */
export const checkRichTextLimit = (
    text = '',
    limit: { FIELD?: number; TEXT?: number },
    fieldRegexp = DEFAULT_FIELD_REGEX
) => {
    const fieldCount = size(text.match(fieldRegexp)); // 字段数
    const textLength = size(trim(text.replace(fieldRegexp, ''))); // 文字数

    const { FIELD, TEXT } = limit;

    return {
        // 字段数达到限制
        isFieldMax: isNumber(FIELD) ? fieldCount < FIELD : true,
        // 字符数超过限制
        isTextValid: isNumber(TEXT) ? textLength <= TEXT : true
    };
};
